import noDataFound from "@assets/images/no-data.png";
import { trans } from "@mongez/localization";

type NoDataFoundProps = {
  message?: string;
};

export function NoDataFound({ message }: NoDataFoundProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-6">
      <img src={noDataFound} alt="no data found" width={300} height={300} />
      <p className="text-center text-lg font-bold lg:text-xl">
        {message || trans("noDataFound")}
      </p>
    </div>
  );
}
